import React from "react";

const TermsConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-[#fc3c04]">Terms & Conditions</h1>

      <p className="mb-4">
        Welcome to <strong className="text-[#fc3c04]">Foict</strong>! These terms and conditions outline the rules and regulations for the use of our job and course portal website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">1. Acceptance of Terms</h2>
      <p className="mb-4">
        By accessing this website, you agree to comply with these terms and conditions. If you do not agree with any part of the terms, please refrain from using our platform.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">2. Intellectual Property</h2>
      <p className="mb-4">
        All content, logos, data, course materials, job listings, and visual elements on this website are the intellectual property of <strong className="text-[#fc3c04]">Foict</strong> and are protected under applicable copyright and intellectual property laws.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">3. User Restrictions</h2>
      <p className="mb-4">
        Users are strictly prohibited from: copying or redistributing course materials or job listings, misusing any data for commercial gain, violating any local or international regulations, and using automated tools to extract content from the platform.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">4. Limitation of Liability</h2>
      <p className="mb-4">
        <strong className="text-[#fc3c04]">Foict</strong> shall not be held liable for any direct, indirect, or consequential losses or damages resulting from the use of our portal, including failure to secure employment or course enrollment.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">5. Account Responsibility</h2>
      <p className="mb-4">
        You are responsible for maintaining the confidentiality of your account credentials and agree to accept responsibility for all activities that occur under your account.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2 text-[#345bf3]">6. Changes to Terms</h2>
      <p className="mb-4">
        We reserve the right to modify these terms at any time. Continued use of the platform after any changes indicates your acceptance of the revised terms.
      </p>

      <p className="mt-8">
        For any questions regarding our Terms & Conditions, please contact us at <a href="mailto:support@foict.com" className="text-[#fc3c04] hover:underline"> subhash@foict.com</a>.
      </p>
    </div>
  );
};

export default TermsConditions;
